// extracted by mini-css-extract-plugin
export default {"base":"Button_base__wb2g+","iconContainer":"Button_iconContainer__TPDvX","primary":"Button_primary__9MLUH"};